import React from 'react';

function FormatDollarAmount({ amount }) {
  const isNegative = amount < 0;
  const parsedAmount = Math.abs(amount).toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    roundingMode: 'halfCeil',
  });

  return `${isNegative ? '-' : ''}$${parsedAmount}`;
}

export default React.memo(FormatDollarAmount);
